module.exports = {
        srcSet: "/_next/static/images/sharp-icon-20-286959998e34307b.png"+" 20w"+","+"/_next/static/images/sharp-icon-40-698da561689cc4f9.png"+" 40w"+","+"/_next/static/images/sharp-icon-60-fb180f9c6ed365b4.png"+" 60w",
        images: [{path: "/_next/static/images/sharp-icon-20-286959998e34307b.png",width: 20,height: 20},{path: "/_next/static/images/sharp-icon-40-698da561689cc4f9.png",width: 40,height: 40},{path: "/_next/static/images/sharp-icon-60-fb180f9c6ed365b4.png",width: 60,height: 60}],
        src: "/_next/static/images/sharp-icon-60-fb180f9c6ed365b4.png",
        toString: function(){return "/_next/static/images/sharp-icon-60-fb180f9c6ed365b4.png"},
        
        width: 60,
        height: 60
      }